export default __webpack_public_path__ + "static/backgroundMedia-e239d9c3d76a96db636b2f9104821ac5.jpg";